import React from "react";
import { IconName } from "../../../../../styles/icons";
import { Stack } from "../../../../Stacks/Stack/Stack";
import { StopPropagation } from "../../../../StopPropagation/StopPropagation";
import { Toggle, ToggleProps } from "../../../../Toggle/Toggle";
import { gapBetweenElements } from "../../../ListItems/shared/styles";
import { OperationalContent } from "../../shared/OperationalContent";
import { finalColumnExtraPadding } from "../../shared/styles";
import { FinalColumnWithIcon } from "../shared/FinalColumnWithIcon";
import { FinalColumnProps } from "../shared/props";
import { getFinalColumnContent } from "../shared/utils";

export interface BaseToggleFinalColumnProps {
    /**
     * ToggleProps to render a Toggle component at the far right of the column (LTR).
     */
    readonly toggleProps: ToggleProps;

    /**
     * Optional iconName to render an Icon at the far right of the column (LTR)
     */
    readonly iconName?: IconName;
}

export type ToggleFinalColumnProps = FinalColumnProps & BaseToggleFinalColumnProps;

export const ToggleFinalColumn: React.FC<ToggleFinalColumnProps> = ({
    toggleProps,
    disabled,
    columnAlign = "end",
    iconName,
    operationalData,
    ...otherProps
}) => (
    <FinalColumnWithIcon iconName={iconName} disabled={disabled}>
        <Stack
            horizontal={true}
            grow={true}
            horizontalAlign={columnAlign === "end" ? "space-between" : "start"}
            childrenGap={gapBetweenElements}
            verticalAlign="center"
        >
            <Stack>
                <OperationalContent
                    operationalData={operationalData}
                >
                    {getFinalColumnContent(otherProps, disabled)}
                </OperationalContent>
            </Stack>
            <Stack padding={finalColumnExtraPadding}>
                <StopPropagation>
                    <Toggle
                        {...toggleProps}
                        labelPosition="inline"
                        disabled={disabled}
                    />
                </StopPropagation>
            </Stack>
        </Stack>
    </FinalColumnWithIcon>
);
